'use client'

import React, { useEffect } from 'react'
import Link from 'next/link'

import { X } from 'lucide-react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { usePreOpen } from '@/hooks/usePreOpen'

interface HamburgerMenuProps {
  isOpen: boolean
  onClose: () => void
  onMypageClick: () => void
}

export const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
  isOpen,
  onClose,
  onMypageClick,
}) => {
  const { isPreOpen } = usePreOpen()

  // ハンバーガーメニューが開いている時はbody要素のスクロールを禁止する
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }

    return () => {
      document.body.classList.remove('overflow-hidden')
    }
  }, [isOpen])

  return (
    <div
      className={`min-md:hidden fixed overflow-y-scroll inset-0 z-50 transition-all duration-500 ease-in-out w-full lg:w-96 m-0 lg:rounded-lg bg-background ${
        isOpen
          ? 'opacity-100 transform translate-x-0'
          : 'opacity-0 transform -translate-x-full pointer-events-none'
      }`}
    >
      <div className="min-h-screen overflow-auto">
        {/* Navigation */}
        <div className="flex items-center justify-end p-5 border-b border-[#DEDEDE]">
          <button type="button" onClick={onClose} aria-label="Close menu">
            <X strokeWidth={0.5} />
          </button>
        </div>

        <div className="p-8 pt-3.5 flex flex-col min-h-[calc(100vh-100px)]">
          {/* 下取りに出す */}
          <section className="space-y-4 pt-2 flex flex-col flex-1">
            {/*　TODO: 本リリース時に isPreOpen 削除　*/}
            {isPreOpen && (
              <>
                <Link
                  href="/listings?gender=1"
                  onClick={onClose}
                  className="text-[26px] font-bold"
                >
                  ウィメンズ
                </Link>
                <Link
                  href="/listings?gender=0"
                  onClick={onClose}
                  className="text-[26px] font-bold"
                >
                  メンズ
                </Link>
                <Link
                  href="/listings?gender=2"
                  onClick={onClose}
                  className="text-[26px] font-bold"
                >
                  キッズ
                </Link>
              </>
            )}
            <Accordion type="single" className="w-full" collapsible>
              <AccordionItem value="tradein">
                <AccordionTrigger className="text-xl font-bold py-1.5">
                  下取り申請
                </AccordionTrigger>
                <AccordionContent>
                  <>
                    <div className="w-full flex items-center justify-between">
                      <Link
                        href="/tradein"
                        className="pl-4 text-lg leading-8"
                        onClick={onClose}
                      >
                        下取りに出す方法
                      </Link>
                    </div>
                    <div className="w-full flex items-center justify-between">
                      <Link
                        href="/tradein/search"
                        className="pl-4 text-lg leading-8"
                        onClick={onClose}
                      >
                        下取り申請
                      </Link>
                    </div>
                  </>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
            <Link
              href="/about"
              onClick={onClose}
              className="text-[26px] font-bold"
            >
              サービスについて
            </Link>
          </section>
          <div className="mt-auto space-y-4 pb-8">
            <button
              type="button"
              onClick={onMypageClick}
              className="text-[20px] font-bold block text-left"
            >
              マイページ
            </button>
            <Link
              href="/contact"
              onClick={onClose}
              className="text-[26px] font-bold block"
            >
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HamburgerMenu
